import manufacturing from './img/manufacturing.png'
import medal from './img/medal.png';
import warehouse from './img/warehouse.png'; 
import warranty from './img/warranty.png';
import deliveryTruck from './img/delivery-truck.png'

export const img = [manufacturing, medal, warehouse, warranty, deliveryTruck]
